import React from "react";
import CreateCase3 from "../../internal/CreateCase3";

const Index = ({ caseId }) => {
  return <CreateCase3 caseId={caseId} />;
};

export default Index;
